import { useEffect, useState } from 'react';
import { Building, Site } from '../../confi-state';
import { ServiceManager } from '../../services/service-manager';
import styles from './SiteInfoDoc.module.css';

const SiteInfoDoc = ({ currentSite, buildings }: { currentSite: Site, buildings: Building[] }) => {

    const [ufa, setUfa] = useState<number>(0);
    const [gfa, setGfa] = useState<number>(0);
    const [nrSiteTypeUnits, setNrSiteTypeUnits] = useState<{ label: string, total: number, types: { type: string, nr: number }[] }[]>([]);

    useEffect(() => {
        if(buildings.length > 0){
            setUfa(ServiceManager.buildingHelperService.calculateTotalUFAOfSite(buildings));
            setGfa(ServiceManager.buildingHelperService.calculateTotalGFAOfSite(buildings));
            setNrSiteTypeUnits(ServiceManager.buildingHelperService.calculateNrOfUnitsPerType(buildings));
        }
    }, [buildings])

    const computeTotalPrice = () => {
        if (buildings && buildings.length > 0) {
            return ServiceManager.buildingHelperService.calculateCostOfSite(buildings).toLocaleString('nl-NL', {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })
        } else {
            return 0;
        }
    }

    return (
        <div className={styles.SiteInfo} data-testid="SiteInfo">
            <div >
                <h3>Kern gegevens</h3>
                <hr></hr>
                <div className={styles.info}>
                    <div className={styles.half}>
                        <dl>
                            <dt>
                                Gebouwen
                            </dt>
                            <dd data-testid="NrApartments">
                                {buildings.length}
                            </dd>
                            <dt>
                                Kavel Oppervlakte
                            </dt>
                            <dd data-testid="SiteArea">
                                {ServiceManager.buildingHelperService.siteArea(currentSite.border).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ㎡
                            </dd>
                        </dl>
                    </div>
                    <div className={styles.half}>
                        <dl>
                            <dt>
                                Gebruiksoppervlak (GO)
                            </dt>
                            <dd data-testid="SiteGO">
                                {Math.round(ufa).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ㎡
                            </dd>
                            <dt>
                                Bruto vloeroppervlak (BVO)
                            </dt>
                            <dd data-testid="SiteBVO">
                                {Math.round(gfa).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ㎡
                            </dd>
                            <dt>
                                GO/BVO
                            </dt>
                            <dd>
                                {gfa !== 0 ? (ufa / gfa).toFixed(2) : 0}
                            </dd>
                        </dl>
                    </div>
                </div>
                <h3><span>Woningen</span><span className={styles.right}>{ServiceManager.buildingHelperService.calculateTotalAppartmentsOfSite(buildings)}</span></h3>
                <hr></hr>
                <div className={styles.unitNumbers}>
                    {
                        nrSiteTypeUnits.map(n => {
                            return (<div key={n.label} className={styles.third}>
                                <h3><span>{n.label}</span><span className={styles.right}>{n.total}</span></h3>
                                <hr></hr>
                                <ul>
                                    {n.types.map(t => {
                                        return (<li key={n.label + t.type}><span>{t.type}</span><span className={styles.right}>{t.nr}</span></li>)
                                    })}
                                </ul>
                            </div>)
                        })
                    }
                </div>
            </div>
        </div>
    )
};

export default SiteInfoDoc;
